import { Dispatch, SetStateAction, createContext } from 'react';

const setFocusStub: Dispatch<SetStateAction<boolean>> = () => false;
export const FocusContext = createContext({
  isFocused: false,
  setFocus: setFocusStub,
});
